(function(){
  'use strict';
  if(window.innerWidth>=750) return;

  var overlay,imgEl,close,counter,images=[],idx=0;
  var scale=1,lastScale=1,dist0=0,tx=0,ty=0,startX=0,startY=0;

  function build(){
    overlay=document.createElement('div');
    overlay.id='ww-lightbox';
    overlay.innerHTML='<div class="ww-lb-close">&times;</div><div class="ww-lb-counter"></div><div class="ww-lb-img-wrap"><img class="ww-lb-img" /></div>';
    document.body.appendChild(overlay);
    imgEl=overlay.querySelector('.ww-lb-img');
    close=overlay.querySelector('.ww-lb-close');
    counter=overlay.querySelector('.ww-lb-counter');
    close.addEventListener('click',hide);
    overlay.addEventListener('click',function(e){if(e.target===overlay||e.target.classList.contains('ww-lb-img-wrap'))hide();});

    var wrap=overlay.querySelector('.ww-lb-img-wrap');
    wrap.addEventListener('touchstart',onTouchStart,{passive:false});
    wrap.addEventListener('touchmove',onTouchMove,{passive:false});
    wrap.addEventListener('touchend',onTouchEnd,{passive:false});
  }

  function getDist(t){var dx=t[0].clientX-t[1].clientX,dy=t[0].clientY-t[1].clientY;return Math.sqrt(dx*dx+dy*dy);}

  function onTouchStart(e){
    if(e.touches.length===2){dist0=getDist(e.touches);lastScale=scale;e.preventDefault();}
    else if(e.touches.length===1){startX=e.touches[0].clientX-tx;startY=e.touches[0].clientY-ty;}
  }

  function onTouchMove(e){
    if(e.touches.length===2){var d=getDist(e.touches);scale=Math.min(Math.max(lastScale*(d/dist0),1),5);applyTransform();e.preventDefault();}
    else if(e.touches.length===1&&scale>1){tx=e.touches[0].clientX-startX;ty=e.touches[0].clientY-startY;applyTransform();e.preventDefault();}
  }

  function onTouchEnd(e){
    if(e.touches.length===0&&scale<=1.05){scale=1;tx=0;ty=0;applyTransform();}
  }

  function applyTransform(){imgEl.style.transform='translate('+tx+'px,'+ty+'px) scale('+scale+')';}

  function show(i){
    idx=i;scale=1;tx=0;ty=0;
    imgEl.style.transform='none';
    imgEl.src=images[idx].replace(/width=\d+/,'width=1200');
    counter.textContent=(idx+1)+' / '+images.length;
    overlay.classList.add('ww-lb-open');
    document.body.style.overflow='hidden';
  }

  function hide(){
    overlay.classList.remove('ww-lb-open');
    document.body.style.overflow='';
    imgEl.src='';
  }

  function next(){if(idx<images.length-1) show(idx+1);}
  function prev(){if(idx>0) show(idx-1);}

  var swipeX0=0;
  document.addEventListener('touchstart',function(e){
    if(!overlay||!overlay.classList.contains('ww-lb-open'))return;
    if(e.touches.length===1&&scale<=1.05) swipeX0=e.touches[0].clientX;
  });
  document.addEventListener('touchend',function(e){
    if(!overlay||!overlay.classList.contains('ww-lb-open'))return;
    if(scale>1.05)return;
    var dx=e.changedTouches[0].clientX-swipeX0;
    if(Math.abs(dx)>60){dx<0?next():prev();}
  });

  /* Capture clicks on product media items before Dawn's modal-opener fires */
  document.addEventListener('click',function(e){
    /* Only intercept on product pages with product media */
    var mediaItem=e.target.closest('.product__media-item');
    if(!mediaItem) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    images=[];
    document.querySelectorAll('.product__media-item img').forEach(function(im){
      var s=im.currentSrc||im.src; if(s) images.push(s);
    });
    if(!images.length) return;

    var clicked=mediaItem.querySelector('img');
    var ci=clicked?(clicked.currentSrc||clicked.src):'';
    var foundIdx=images.indexOf(ci);
    if(!overlay) build();
    show(foundIdx>=0?foundIdx:0);
  },true); /* true = capturing phase */

  /* Lightbox styles */
  var style=document.createElement('style');
  style.textContent=[
    '#ww-lightbox{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.95);z-index:99999;display:none;align-items:center;justify-content:center;flex-direction:column;}',
    '#ww-lightbox.ww-lb-open{display:flex;}',
    '.ww-lb-close{position:absolute;top:12px;right:16px;font-size:2rem;color:#fff;z-index:10;cursor:pointer;line-height:1;padding:8px;}',
    '.ww-lb-counter{position:absolute;top:16px;left:16px;color:rgba(255,255,255,0.7);font-size:0.85rem;z-index:10;}',
    '.ww-lb-img-wrap{width:100%;height:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;touch-action:none;}',
    '.ww-lb-img{max-width:95%;max-height:85vh;object-fit:contain;transform-origin:center center;will-change:transform;}',
  ].join('\n');
  document.head.appendChild(style);
})();
